import React from 'react'
import "@google/model-viewer/dist/model-viewer";
function Viewer_ar() {
  const modelRef = React.useRef();
  return (
    <div className='ar w-1/2 h-[90vh] mx-auto'>
      
      <model-viewer
        src="sources/Model2.glb"
        ios-src="sources/model.usdz"
        alt="A 3D model of an People"
        camera-controls
        auto-rotate
        auto-play
        ar ar-scale="fixed"
        ar-modes="webxr scene-viewer quick-look"
        touch-action="pan-y"

        xr-environment
        
      ></model-viewer>

    </div>
  )
}

export default Viewer_ar